import axios from "axios";

// Set base URL for API calls
// const baseURL = process.env.VUE_APP_API_URL || "http://localhost:8000/api";
const baseURL = "https://api.market.vijan.ai/api";
// const baseURL = "http://localhost:8000/api";
axios.defaults.baseURL = baseURL;

// Export media URL for use in components
// export const mediaURL = process.env.VUE_APP_MEDIA_URL || "http://localhost:8000/storage";
export const mediaURL = "https://blr1.vultrobjects.com/space-1/";

// Function to setup interceptors after store is available
export function setupInterceptors(store) {
  // Request interceptor to add auth token and company context
  axios.interceptors.request.use(
    (config) => {
      // Clear previous errors
      if (store) {
        store.dispatch("errors/setErrors", {});
        store.dispatch("errors/setStatus", null);
      }

      // Add auth token if available
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // Add company context if available
      if (store) {
        const company = store.getters["auth/company"];
        if (company && company.id) {
          config.headers["company-id"] = company.id;
        }
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor to handle errors globally
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Handle authentication errors
      if (error.response && error.response.status === 401) {
        if (store) {
          store.dispatch("auth/logOut");
        }
        localStorage.removeItem("token");
        localStorage.removeItem("company");
        window.location.href = "/login";
      }

      // Handle validation errors
      if (error.response && error.response.data && error.response.data.errors) {
        const errors = error.response.data.errors;
        Object.keys(errors).forEach((key) => {
          errors[key] = errors[key][0];
        });
        if (store) {
          store.dispatch("errors/setErrors", errors);
        }
      }

      // Set error status
      if (error.response && store) {
        store.dispatch("errors/setStatus", error.response.status);
      }

      return Promise.reject(error);
    }
  );

  // Set initial URLs in store
  if (store) {
    store.dispatch("settings/setBaseUrl", baseURL);
    store.dispatch("settings/setMediaUrl", mediaURL);
  }
}

export default axios;